import React, { useRef } from "react";
import {
  Chart,
  Series,
  ArgumentAxis,
  ValueAxis,
  Legend,
  Tooltip,
  CommonSeriesSettings,
  Format,
  Label,
} from "devextreme-react/chart";
import ChartCard from "components/common/pyramid/ChartCard";

const CountriesWithBucket = ({ data, palette }) => {
  const chartRef = useRef(null);

  // Préparer les données pour n'afficher que les 10 premiers pays
  const prepareData = () => {
    // Calculer la somme totale pour chaque pays (tous buckets confondus)
    const countriesWithTotal = data.map((country) => ({
      ...country,
      total:
        country.SumEclBucket1Departure +
        country.SumEclBucket1Arrival +
        country.SumEclBucket2Departure +
        country.SumEclBucket2Arrival,
    }));

    // Trier par total décroissant et prendre les 10 premiers
    return countriesWithTotal
      .sort((a, b) => b.total - a.total)
      .slice(0, 10)
      .map((country) => ({
        ...country,
        CountryLib:
          country.CountryLib.charAt(0) +
          country.CountryLib.slice(1).toLowerCase(),
      }))
      .reverse();
  };

  const customizeTooltip = (arg) => {
    return {
      html: `
        <div style="padding: 10px;">
          <div style="font-weight: bold; margin-bottom: 5px;">${arg.argumentText}</div>
          <div><span style="font-weight: 500;">${arg.seriesName}</span>: ${arg.valueText} €</div>
        </div>
      `,
    };
  };

  return (
    <ChartCard
      title="Top 10 Countries with buckets"
      chartRef={chartRef}
      showLabelsOnExport={false}
      palette={palette}
    >
      <div className="p-4">
        <Chart
          dataSource={prepareData()}
          id="countriesChart"
          ref={chartRef}
          rotated={true}
        >
          <CommonSeriesSettings type="stackedbar" barPadding={0.1} />

          <Series
            valueField="SumEclBucket1Departure"
            argumentField="CountryLib"
            name="ECL departure - Bucket 1"
            // color="#e67e00"
            color={palette[0]}
            stack="departure"
          />
          <Series
            valueField="SumEclBucket2Departure"
            argumentField="CountryLib"
            name="ECL departure - Bucket 2"
            // color="#f5803e"
            color={palette[3]}
            stack="departure"
          />
          <Series
            valueField="SumEclBucket1Arrival"
            argumentField="CountryLib"
            name="ECL arrival - Bucket 1"
            // color="#4695ff"
            color={palette[1]}
            stack="arrival"
          />
          <Series
            valueField="SumEclBucket2Arrival"
            argumentField="CountryLib"
            name="ECL arrival - Bucket 2"
            // color="#727cf5"
            color={palette[2]}
            stack="arrival"
          />

          <ArgumentAxis>
            <Label wordWrap="none" />
          </ArgumentAxis>

          <ValueAxis>
            <Format type="fixedPoint" precision={0} />
          </ValueAxis>

          <Legend
            visible={true}
            horizontalAlignment="right"
            verticalAlignment="bottom"
            columnCount={2}
            rowCount={2}
            backgroundColor="rgba(255, 255, 255, 0.8)"
            border={{
              visible: true,
              color: "#e5e5e5",
              opacity: 0.7,
            }}
            paddingLeftRight={10}
            paddingTopBottom={10}
            markerSize={12}
            position="inside"
          />

          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip}
            format="fixedPoint"
            precision={2}
          />
        </Chart>
      </div>
    </ChartCard>
  );
};

export default CountriesWithBucket;
